import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const LinksContainer = styled.div`
  border-color: ${Styles.color.black};
  border-style: solid;
  border-width: 1px 0;
  margin: 0 0 1.5rem 0;

  ${Styles.desktop`
  align-items: center;
  display: flex;
  justify-content: space-around;
  margin:  0 0 2.5rem 0;
`};
`;

const LinkStyles = css`
  border-bottom: solid 1px ${Styles.color.black};
  color: ${Styles.color.black};
  display: block;
  font-family: ${Styles.fontFamily.base};
  font-size: 1rem;
  padding: 1.125rem 0;
  text-decoration: none;

  :last-of-type {
    border-bottom: 0;
  }

  ${Styles.desktop`
    border-bottom: 0;
    font-size: 1.625rem;
    padding: 2rem 0
  `};
`;

export const StyledLink = styled(Link)`
  ${LinkStyles}
`;
export const StyledAnchor = styled.a`
  ${LinkStyles}
`;
